import styled from 'styled-components';
import { Col } from '@vds/grids';

export const MoversWrapper = styled.div`
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  margin-right: ${(props) => props.mRight};
  margin-left: ${(props) => props.mLeft};
  padding-top: ${(props) => props.pTop};
  padding-bottom: ${(props) => props.pBottom};
  padding-right: ${(props) => props.pRight};
  padding-left: ${(props) => props.pLeft};
`;

export const Margin = styled.div`
  margin-top: ${(props) => props.top};
  margin-bottom: ${(props) => props.bottom};
  margin-right: ${(props) => props.right};
  margin-left: ${(props) => props.left};
`;

export const Padding = styled.div`
  padding-top: ${(props) => props.top};
  padding-bottom: ${(props) => props.bottom};
  padding-right: ${(props) => props.right};
  padding-left: ${(props) => props.left};
`;

export const NoPaddingCol = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
  padding-top: ${(props) => props.top};
  padding-bottom: ${(props) => props.bottom};
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  margin-right: ${(props) => props.mRight};
  margin-left: ${(props) => props.mLeft};
`;

export const AlignCenter = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Font = styled.span`
  font-size: ${(props) => props.fontSize};
  text-transform: ${(props) => props.textTransform};
  line-height: ${(props) => props.lineHeight};
  font-weight: ${(props) => props.fontWeight};
  padding-right: ${(props) => props.right};
  padding-left: ${(props) => props.left};
`;

export const StyledContainer = styled.div`
  min-width: 808px;
  @media (max-width: 768px) {
    min-width: 0;
  }
`;

export const NoPaddingColWidth = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
  padding-top: ${(props) => props.top};
  padding-bottom: ${(props) => props.bottom};
  margin-top: ${(props) => props.mTop};
  margin-bottom: ${(props) => props.mBottom};
  margin-right: ${(props) => props.mRight};
  margin-left: ${(props) => props.mLeft};
  width: ${(props) => props.width};
  max-width: ${(props) => props.width};
`;
